import type { HTMLAttributes } from 'react';
import { cn } from '../utils/cn';

export type BadgeTone =
  | 'neutral'
  | 'petrol'
  | 'clay'
  | 'olive'
  | 'amber'
  | 'blue'
  | 'violet'
  | 'rose'
  | 'ink';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

const toneClasses: Record<BadgeTone, string> = {
  neutral: 'bg-surface-tint text-graphite border-rule-strong',
  petrol: 'bg-petrol-tint text-petrol-deep border-petrol/30',
  clay: 'bg-clay-tint text-clay-deep border-clay/30',
  olive: 'bg-olive-tint text-olive border-olive/30',
  amber: 'bg-amber-tint text-amber border-amber/30',
  blue: 'bg-blue-tint text-blue border-blue/30',
  violet: 'bg-violet-tint text-violet border-violet/30',
  rose: 'bg-rose-tint text-rose border-rose/30',
  ink: 'bg-ink text-white border-ink',
};

export function Badge({ tone = 'neutral', className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px] font-semibold tracking-wide ' +
          'uppercase rounded-full border tnum',
        toneClasses[tone],
        className,
      )}
      {...props}
    />
  );
}
